import { ITempAddress } from "../../../interfaces/temp.interface"
import { IStoreLocation } from "../../../models/data.interface"
import { GeoSearchSelection } from "../../../services/geo-search/geo-search-provider-factory"

export interface IDeliveryAddress {
    locationId: string,
    locations: IStoreLocation[],
    randomId: number,
    selectedStoreKey: string,
    selectedAddress: ITempAddress | null,
    streetAddress: string,
    apartment: string,
    deliveryInstructions: string,
    geoSearch: GeoSearchSelection
}

export interface IDeliveryAddressReferences {
    streetAddress: HTMLInputElement,
    datalist: HTMLDataListElement,
    datalistWv: HTMLUListElement,
    apartment: HTMLInputElement,
    deliveryInstructions: HTMLInputElement
}

export interface IFillInAddress {
    City: string,
    Latitude: number,
    Longitude: number,
    State: string,
    StName: string,
    StNo: string,
    StPreDirAbbr: string,
    StSuffixAbbr: string,
    StPostDirAbbr: string,
    ZipCode: string,
}

export enum ConfirmButtonState {
    ENABLED,
    DISABLED,
}